/**
 * Full Twinnee logo (clapperboard + wordmark) for navbars, headers and footers.
 * Size it with a height class (e.g. `h-8`); width follows the logo's ~3.3:1 aspect ratio.
 * The artwork is light-on-transparent, so it is meant for dark surfaces.
 */
export function TwinneeWordmark({ className = '', alt = 'Twinnee', ...rest }) {
  return (
    <img
      src="/twinnee-wordmark@96.png"
      srcSet="/twinnee-wordmark@96.png 1x, /twinnee-wordmark@192.png 2x, /twinnee-wordmark.png 3x"
      alt={alt}
      draggable={false}
      decoding="async"
      className={`twinnee-wordmark block w-auto max-w-none shrink-0 select-none object-contain ${className}`}
      {...rest}
    />
  );
}

export default TwinneeWordmark;
